import { catalogs } from "./locale-catalogs.js";
import { languages } from "./languages.js";
export const messages = Object.fromEntries(
  Object.entries(catalogs).map(([id, data]) => [id, data.ui]),
);
export const locales = Object.fromEntries(
  Object.entries(languages).map(([id, name]) => [id, { name, dir: "ltr" }]),
);
export function resolveLocale(value) {
  const id = String(value ?? "")
    .toLowerCase()
    .replaceAll("_", "-");
  if (locales[id]) return id;
  if (
    id === "nb" ||
    id.startsWith("nb-") ||
    id === "nn" ||
    id.startsWith("nn-")
  )
    return "no";
  return locales[id.split("-")[0]] ? id.split("-")[0] : "en";
}
export function preferredLocale(saved = {}, browserLanguage = "en") {
  // Older saves stored an English UI beside a different language selected by flag.
  return resolveLocale(
    saved.uiLanguageVersion
      ? saved.locale
      : saved.language || saved.locale || browserLanguage,
  );
}
export function translator(locale) {
  return (key, values = {}) =>
    (messages[locale]?.[key] ?? messages.en[key] ?? key).replace(
      /\{(\w+)\}/g,
      (_, key) => String(values[key] ?? `{${key}}`),
    );
}
export function quantity(locale, key, count) {
  const plural = new Intl.PluralRules(locale).select(count);
  const suffix = messages[locale]?.[`${key}_${plural}`] ? plural : "other";
  return translator(locale)(`${key}_${suffix}`, {
    count: new Intl.NumberFormat(locale).format(count),
  });
}
// Catalogs supplement pack-local text by stable IDs, so new packs still own their copy.
export function translateWorlds(worlds) {
  for (const world of worlds) {
    for (const [locale, { content, ui }] of Object.entries(catalogs)) {
      for (const field of ["title", "description"]) {
        const value = content[`${world.id}.${field}`];
        if (value && !(world.preview && field === "description")) world[field][locale] = value;
      }
      for (const level of world.levels)
        if (content[level.id]) level.name[locale] = content[level.id];
      if (world.beta && !(world.id === 'aegean' && world.contentRevision >= 3)) {
        world.selection.badge[locale] = ui.betaLabel;
        world.previewNote[locale] = ui[world.id === 'aegean' ? 'aegeanBetaNote' : 'templeBetaNote'];
      }
      if (world.id === 'aegean' && !world.contentRevision) {
        world.title[locale] = ui.aegeanTitle;
        world.previewTitle[locale] = ui.aegeanTitle;
        world.description[locale] = ui.aegeanDescription;
        for (const district of world.districts ?? []) district.name[locale] = ui.harbour;
        for (const level of world.levels) level.landmark[locale] = ui.harbour;
      }
      if (world.selection?.section === 'seasonal') world.selection.badge[locale] = ui.seasonal;
    }
  }
  return worlds;
}
export const errors = {
  "There is no trail there. Try turning before moving.": "noTrail",
  "That bridge is broken. Can you jump over it?": "broken",
  "Something is blocking the way. Try a jump or another route.": "blocked",
  "That tile is already lit. Find a route that visits each tile once.":
    "alreadyLit",
  "This program keeps repeating. Change the loop or try fewer repetitions.":
    "loopError",
  "Choose a repeat count from 1 to 99.": "repeatError",
  "This block is not supported. Please remove it and try again.": "unsupported",
  "Remove the unsupported block and try again.": "unsupported",
  "Connect your blocks into one program, then run it.": "connect",
};
